import { z } from 'zod'

export const BodyCreateRequestSchema = z.object({
  avatar_file_id: z.number().optional(),
  flows_locked_status: z.record(z.string(), z.boolean()).optional(),
  holders: z.array(z.string()).optional(),
  is_editable: z.boolean().optional(),
  is_protected: z.boolean().optional(),
  is_tracked: z.boolean().optional(),
  page_id: z.string().optional(),
  template_id: z.string().or(z.number()).optional(),
  title: z.string().optional(),
  template_fields: z.array(z.looseObject({})).optional(),
})

export type BodyCreateRequest = z.infer<typeof BodyCreateRequestSchema>
